export const clientsKeys = {
  all: ['clients'] as const,
  list: (...args: unknown[]) => [...clientsKeys.all, 'list', ...args] as const,
};
